import { EMaintenanceStatusType } from 'core/model/enums';
import type { TMaintenanceStatusValues, TUpdateMaintenanceParams } from 'core/model/interfaces/maintenance';
import { formatDateTimeToIso, formatLocaleDate, formatLocaleTime } from 'shared/utils/date.utils';
import type { IMaintenanceStatusValuesDTO, TMaintenanceListItemDTO } from './maintenance.dto';

export const getMaintenanceStatusValues = (maintenance: TMaintenanceListItemDTO): TMaintenanceStatusValues => {
  const { startDate: startDatetime, endDate: endDatetime } = maintenance;

  if (startDatetime && endDatetime) {
    const startDate = formatLocaleDate(startDatetime);

    const startTime = formatLocaleTime(startDatetime);

    const endDate = formatLocaleDate(endDatetime);

    const endTime = formatLocaleTime(endDatetime);

    return {
      status: EMaintenanceStatusType.SCHEDULED,
      startDate,
      startTime,
      endDate,
      endTime,
    };
  }

  if (maintenance.active) {
    return {
      status: EMaintenanceStatusType.ACTIVE,
    };
  }

  return {
    status: EMaintenanceStatusType.INACTIVE,
  };
};

export const toMaintenanceStatusValues = (maintenance: TUpdateMaintenanceParams): IMaintenanceStatusValuesDTO => {
  if (maintenance.status === EMaintenanceStatusType.SCHEDULED) {
    const { startDate, startTime, endDate, endTime } = maintenance;

    const startDatetime = formatDateTimeToIso(startDate as Date, startTime);

    const endDatetime = formatDateTimeToIso(endDate as Date, endTime);

    return {
      active: true,
      startDate: startDatetime,
      endDate: endDatetime,
    };
  }

  return {
    active: maintenance.status === EMaintenanceStatusType.ACTIVE,
    startDate: null,
    endDate: null,
  };
};
